export default __webpack_public_path__ + "static/media/earth-round.00172bde.svg";